import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { BackofficeService } from "../../services/backoffice.service";
import {
  closeAlertAction,
  showAlertAction,
} from "../../store/actions/alert.action";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { IAppState } from "../../store/state/app.state";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { merge, Observable, of as observableOf } from "rxjs";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { iconsLibrary } from "../../../theme/constants";
import { MatTableDataSource } from "@angular/material/table";
import { CompanyService } from "../../services/company.service";
import { EInputStyleType } from "../../data-types/input-style.enum";

@Component({
  selector: "cowing-core-backoffice-companies",
  templateUrl: "./backoffice-companies.component.html",
  styleUrls: ["./backoffice-companies.component.scss"],
})
export class BackofficeCompaniesComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  resultsLength: any;

  constructor(
    private _store: Store<IAppState>,
    private translate: TranslateService
  ) {}
  public displayedColumns: string[] = [];
  public dataSource = null;
  public companyStates = [];
  public EInputStyleType = EInputStyleType;
  private buildCompany(data) {
    return {
      id: data.id,
      name: data.name,
      company_name: data.company_name,
      business_name: data.business_name,
      business_group: data.business_group,
      email: data.email,
      fiscal_address: data.fiscal_address,
      phone: data.phone,
      tax_id: data.tax_id,
      total_cowings: data.total_cowings,
      state_id: data.state_id,
    };
  }
  ngOnInit() {
    BackofficeService.instance.companyModified.subscribe((val) => {
      this.paginator.page.emit();
    });
    this.getCompanyStates();
  }
  async ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this._store.dispatch(showLoadingAction({}));
          return BackofficeService.instance.getCompanies({
            page: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize,
          });
        }),
        map((data) => {
          this._store.dispatch(closeLoadingAction({}));
          this.resultsLength = data.total_elements;
          return data["companies"];
        }),
        catchError((e) => {
          this._store.dispatch(
            showAlertAction({
              payload: {
                message: e.error,
                title: this.translate.instant("general.caution"),
                type: "error",
              },
            })
          );
          this._store.dispatch(closeLoadingAction({}));
          return observableOf([]);
        })
      )
      .subscribe((data) => {
        const dataFiltered = data.map((company) => this.buildCompany(company));
        if (!this.displayedColumns.length) {
          this.displayedColumns = Object.keys(dataFiltered[0]);
          this.displayedColumns.push("actions");
        }
        console.log(dataFiltered);
        this.dataSource = new MatTableDataSource(dataFiltered);
      });

    // await this.getData();
  }

  public async changeStatus(newStatus, companyId) {
    this._store.dispatch(showLoadingAction({}));
    try {
      const response = await BackofficeService.instance.changeCompanyStatus(
        companyId,
        newStatus.value
      );
      this.paginator.page.emit();
    } catch (e) {
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  private async getCompanyStates() {
    this._store.dispatch(showLoadingAction({}));
    try {
      const response = await CompanyService.instance.getCompanyStates();
      this.companyStates = response;
    } catch (e) {
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  public editCompany(company) {
    this._store.dispatch(
      showAlertAction({
        payload: {
          message: null,
          title: null,
          type: "editCompany",
          editCompanyId: company.id,
        },
      })
    );
  }
  public deleteCompany(company) {
    console.log(company);
    this._store.dispatch(
      showAlertAction({
        payload: {
          message: "",
          title: "Â¿Desea eliminar esta compaÃ±ia?",
          type: "deleteCompany",
          deleteCompanyId: company.id,
        },
      })
    );
  }
  public get getEditIcon() {
    return `${iconsLibrary.editBackoffice}`;
  }
  public get getDeleteIcon() {
    return `${iconsLibrary.trashBackoffice}`;
  }
}
